import React, { FC } from "react";

import { AdventDoor } from "apps/user/learner/api/types";
import { DoorMechanic } from "apps/user/learner/lib/advent-door-mechanics";

import BreathMechanic from "./mechanics/BreathMechanic";
import ChoiceMechanic from "./mechanics/ChoiceMechanic";
import DoneMechanic from "./mechanics/DoneMechanic";
import TimerMechanic from "./mechanics/TimerMechanic";
import WriteMechanic from "./mechanics/WriteMechanic";
import { CompleteDoor } from "./mechanics/shared";

interface DoorMechanicPanelProps {
  door: AdventDoor;
  mechanic: DoorMechanic;
  onComplete: CompleteDoor;
}

/** What the learner does inside the door, by its mechanic. */
const DoorMechanicPanel: FC<DoorMechanicPanelProps> = ({
  door,
  mechanic,
  onComplete,
}) => {
  const props = { door, onComplete };
  switch (mechanic.kind) {
    case "NONE":
      return null;
    case "DONE":
      return <DoneMechanic {...props} />;
    case "WRITE":
      return (
        <WriteMechanic
          {...props}
          questions={mechanic.questions}
          answers={mechanic.answers}
        />
      );
    case "TIMER":
      return <TimerMechanic {...props} minutes={mechanic.minutes} />;
    case "BREATH":
      return (
        <BreathMechanic
          {...props}
          breaths={mechanic.breaths}
          inhaleSeconds={mechanic.inhaleSeconds}
          exhaleSeconds={mechanic.exhaleSeconds}
        />
      );
    case "CHOICE":
      return (
        <ChoiceMechanic
          {...props}
          options={mechanic.options}
          allowOther={mechanic.allowOther}
          choice={mechanic.choice}
        />
      );
    default:
      throw new Error(`Unhandled mechanic ${JSON.stringify(mechanic)}`);
  }
};

export default DoorMechanicPanel;
